import { ITrackVariant } from 'base/interfaces/product';

export function calcRetailPrice(variants: ITrackVariant[]): number {
    let total: number = 0;
    variants.forEach(variant => {
        const shopPrice = Number(variant.dealPrice) > 0 ? Number(variant.dealPrice) : Number(variant.shopPrice)
        const num = Number(variant.num) || 1;
        total += (shopPrice * num);
    });
    return Number(total.toFixed(2));
}